export default __webpack_public_path__ + "src/assets/icn-swap.450af2e78559312eaba21b16ada0f5c4.svg";